import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { Subtitle2, fontSizes, colors, spacing } from 'ui/theme';
import {
  linkedWorkflowsLabel,
  LINKED_WORKFLOWS_CONTENT_TEST_ID,
  LINKED_WORKFLOWS_LABEL_TEST_ID,
} from './constants';
import { StyledListForLinkedWorkflows } from './styled';

const TextSkeletonContainer = styled.div`
  padding: ${spacing.quarter} 0;
`;

const TextSkeleton = styled(Skeleton)`
  height: ${fontSizes.s16};
  background-color: ${colors.grey5};
  width: ${(props: { $skeletonWidth: number }) => props.$skeletonWidth}%;
`;

export const LinkedWorkflowsListLoadingSkeleton = () => (
  <>
    <Subtitle2 data-test={LINKED_WORKFLOWS_LABEL_TEST_ID}>{linkedWorkflowsLabel}</Subtitle2>
    <StyledListForLinkedWorkflows data-test={LINKED_WORKFLOWS_CONTENT_TEST_ID}>
      <li>
        <TextSkeletonContainer>
          <TextSkeleton $skeletonWidth={90} />
        </TextSkeletonContainer>
      </li>
      <li>
        <TextSkeletonContainer>
          <TextSkeleton $skeletonWidth={60} />
        </TextSkeletonContainer>
      </li>
    </StyledListForLinkedWorkflows>
  </>
);
